<template>
    <div>
        <h1 style="font-size: 24px; color: black;">专区管理</h1>
        <div style="margin-bottom: 10px;">
            <el-button type="primary" @click="showAddFormDialog('添加专区')">添加专区</el-button>
        </div>
        <div>
            <el-dialog :title="dialogTitle" :visible.sync="addFormDialogVisible" center @close="closeAddFormDialog"
                       :close-on-click-modal="false">
                <el-form :model="addForm">
                    <el-form-item label="标题" :label-width="labelWidth">
                        <el-input type="text" v-model="addForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="副标题" :label-width="labelWidth">
                        <el-input type="text" v-model="addForm.subTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="是否可用：" :label-width="labelWidth">
                        <el-switch v-model="addForm.isOpen"
                                   :active-value=true
                                   :inactive-value=false
                                   active-text="开启"
                                   inactive-text="关闭">
                        </el-switch>
                    </el-form-item>
                    <el-table-column label="内容顶部主图">
                        <template slot-scope="scope">
                            <template v-if="scope.row.contentIcon">
                                <img :src="VUE_APP_CDN_URL+scope.row.contentIcon" width="70px" height="100px" alt=""/>
                            </template>
                        </template>
                    </el-table-column>
                    <el-form-item label="跳转类型" :label-width="labelWidth">
                        <el-select v-model="addForm.zoneJumpType" placeholder="请选择">
                            <el-option v-for="t in zoneJumpTypeEnum" :key="t.code" :value="t.code"
                                       :label="t.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="icon:" :label-width="labelWidth">
                        <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleIconSuccess"
                            :before-upload="beforeIconUpload"
                        >
                            <!-- 扩大点击区域的容器 -->
                            <div class="upload-box">
                                <img v-if="addForm.icon" :src="VUE_APP_CDN_URL+addForm.icon" class="upload-img" alt=""/>
                                <div v-else class="upload-placeholder">
                                    <i class="el-icon-plus"></i>
                                    <span>点击上传图标</span>
                                </div>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="专区类型" :label-width="labelWidth">
                        <el-select v-model="addForm.templateNavType" placeholder="请选择">
                            <el-option v-for="t in templateNavTypeEnum" :key="t.code" :value="t.code"
                                       :label="t.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否查看更多标记：" :label-width="labelWidth">
                        <el-switch v-model="addForm.isMore"
                                   :active-value=true
                                   :inactive-value=false
                                   active-text="开启"
                                   inactive-text="关闭">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="排序" :label-width="labelWidth">
                        <el-input-number :min="1" :max="1000000" style="width: 220px" type="text"
                                         v-model="addForm.sortRank"></el-input-number>
                    </el-form-item>
                    <el-form-item label="父节点" :label-width="labelWidth">
                        <el-cascader v-model="addForm.parentId" :options="discovers" :props="optionProps"
                                     clearable collapse-tags>
                        </el-cascader>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmAddFormDialog">确 定</el-button>
                        <el-button type="info" @click="closeAddFormDialog">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
        <div>
            <tree-table class="treeTable" :data="discovers" :columns="columns" :selection-type="false"
                        :expand-type="false"
                        border :show-row-hover="false" :is-fold="false">
                <template slot="operate" slot-scope="scope">
                    <el-button size="mini"
                               type="primary"
                               @click="showAddFormDialog('修改专区', scope.row)">编辑
                    </el-button>
                    <el-button size="mini"
                               type="danger"
                               @click="handelDelete(scope.row)">删除
                    </el-button>
                    <el-button size="mini" type="success" @click="showSelectorDialog(scope.row)">选品</el-button>
                </template>
            </tree-table>
        </div>

        <div>
            <el-dialog title="选品管理"
                       center
                       :visible.sync="selectorDialogVisible"
                       @open="selectorFunction"
                       @close="selectorDialogVisible=false"
                       :close-on-click-modal="false"
                       :destroy-on-close="true"
                       width="1500px">
                <h4>专区名称:<font size="6" bold>{{ selectorFunction().name }}</font>
                </h4>
                <div style="margin-bottom: 10px;">
                    <el-card class="form-container" style="margin-top: 25px">
                        <el-row type="flex" align="middle">
                            <el-col :span="5">
                                <span> 标题：</span>
                                <el-input style="width: 300px" placeholder="模糊查询" v-model="query.title"></el-input>
                            </el-col>
                            <el-col :span="6">
                                <el-button type="primary" @click="queryDiscoverDetails">查询</el-button>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>

              <template>
                <h4>选择素材</h4>
                <el-table border :data="detailList" ref="multipleTable" :row-class-name="rowTableClass"
                          :row-key="getRowKeys"
                          @selection-change="handleSelectionChange">
                  <el-table-column
                      type="selection"
                      :reserve-selection="true"
                      width="55">
                  </el-table-column>
                  <el-table-column prop="id" label="id"></el-table-column>
                  <el-table-column prop="title" label="标题"></el-table-column>
                  <el-table-column prop="subTitle" label="副标题"></el-table-column>

                  <el-table-column label="icon">
                    <template slot-scope="scope">
                      <template v-if="scope.row.icon">
                        <img :src="VUE_APP_CDN_URL+scope.row.icon" width="70px" height="100px" alt=""/>
                      </template>
                    </template>
                  </el-table-column>

                  <el-table-column prop="jump" label="跳转链接"></el-table-column>
                  <el-table-column prop="startDt" label="开始时间" :formatter="formatDate"></el-table-column>
                  <el-table-column prop="endDt" label="结束时间" :formatter="formatDate"></el-table-column>
                  <el-table-column label="是否生效" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isOpen === true">是</span>
                      <span v-if="scope.row.isOpen === false">否</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="跳转类型">
                    <template slot-scope="scope">
                      <span>{{ getZoneTypeName(scope.row.zoneJumpType) || '未设置' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="summary" label="精简简介"></el-table-column>
                  <!--                <el-table-column prop="contentBody" label="主体内容"></el-table-column>-->
                  <el-table-column label="内容顶部主图">
                    <template slot-scope="scope">
                      <template v-if="scope.row.contentIcon">
                        <img :src="VUE_APP_CDN_URL+scope.row.contentIcon" width="70px" height="100px"
                             alt=""/>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="answerTime" label="上传时间" :formatter="formatDate"></el-table-column>
                </el-table>
                <div>
                  <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="page.page"
                      :page-sizes="[10,50,100]"
                      :page-size="page.size"
                      layout="total, sizes, prev, pager, next"
                      :total="page.total">
                  </el-pagination>
                </div>
              </template>

                <template v-if="selectedDetails.length>0">
                    <h4>已选素材</h4>
                    <el-table border :data="selectedDetails">

                      <el-table-column prop="relId" label="消息推送id"></el-table-column>
                        <el-table-column prop="title" label="标题"></el-table-column>
                        <el-table-column prop="subTitle" label="副标题"></el-table-column>
                        <el-table-column prop="id" label="id"></el-table-column>

                        <el-table-column label="icon">
                            <template slot-scope="scope">
                                <template v-if="scope.row.icon">
                                    <img :src="VUE_APP_CDN_URL+scope.row.icon" width="70px" height="100px" alt=""/>
                                </template>
                            </template>
                        </el-table-column>

                        <el-table-column prop="jump" label="跳转链接"></el-table-column>
                        <el-table-column prop="startDt" label="开始时间" :formatter="formatDate"></el-table-column>
                        <el-table-column prop="endDt" label="结束时间" :formatter="formatDate"></el-table-column>
                        <el-table-column label="是否生效" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isOpen === true">是</span>
                                <span v-if="scope.row.isOpen === false">否</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="跳转类型">
                            <template slot-scope="scope">
                                <span>{{ getZoneTypeName(scope.row.zoneJumpType) || '未设置' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="summary" label="精简简介"></el-table-column>
                        <!--                <el-table-column prop="contentBody" label="主体内容"></el-table-column>-->
                        <el-table-column label="内容顶部主图">
                            <template slot-scope="scope">
                                <template v-if="scope.row.contentIcon">
                                    <img :src="VUE_APP_CDN_URL+scope.row.contentIcon" width="70px" height="100px"
                                         alt=""/>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column prop="answerTime" label="上传时间" :formatter="formatDate"></el-table-column>
                        <el-table-column label="排序" prop="ranking" min-width="100">
                            <template slot-scope="scope">
                                <el-input-number size="mini" v-model="scope.row.ranking"
                                                 @change="disable=true"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger"
                                           @click.native.prevent="deleteRow(scope.$index, scope.row)">移除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>


                <el-form>
                    <div style="text-align: center;">
                        <el-button type="primary"
                                   @click="confirmAddSelect(selectedDetails)">确 定
                        </el-button>
                        <el-button type="info" @click="closeSelectorFormDialog()">返 回</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    allDiscoverDetails,
    allDiscovers,
    allDiscoversEnums,
    deleteDiscover,
    discoverSelected,
    discoverSelector,
    saveDiscover
} from "@/http/womensApi";
import {formatDate} from "@/http/api";

export default {
    inject: ['reload'],
    name: "Discover",
    data() {
        return {
            uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
            VUE_APP_BASE_URL: null,
            VUE_APP_CDN_URL: null,
            addForm: {
                id: null,
                title: null,
                subTitle: null,
                isOpen: null,
                templateNavType: null,
                sortRank: null,
                zoneJumpType: null,
                icon: null,
                isMore: null,
                parentId: null
            },
            selector: {},
            disable: null,
            selectorDialogVisible: false,
            templateNavTypeEnum: null,
            dialogTitle: '',
            labelWidth: '100px',
            addFormDialogVisible: false,
            discovers: [],
            detailList: [],
            selectedDetails: [],
            tempSelectedDetails: [],
            zoneJumpTypeEnum: null,
            headers: {Authorization: this.$store.state.user.token},
            query: {
                title: "",
                size: null,
                page: null
            },
            page: {
                size: 10,
                page: 1,
                total: null
            },
            columns: [
                {
                    label: 'id',
                    prop: 'id',
                    width: 200
                }, {
                    label: '专区标题',
                    prop: 'title',
                    width: 200
                },
                {
                    label: '排序值（数值越小越靠前，用于控制展示顺序）',
                    prop: 'sortRank',
                    width: 200
                },
                {
                    label: '操作',
                    type: 'template',
                    template: 'operate',
                    width: 200
                }],
            optionProps: {
                emitPath: false,
                multiple: false,
                checkStrictly: true,
                value: 'id',
                label: 'title',
                children: 'children',
            },
        }
    },
    methods: {
        queryDiscoverDetails() {
            this.page.page = 1;
            this.detailsSelectorTemp();
        },
        handelDelete(id) {
            this.$confirm('确认是否删除?', '警告', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteDiscover(id.id).then(resp => {
                    if (resp.data.status === 0) {
                        this.$message({
                            message: "操作成功",
                            type: 'success'
                        });
                        this.reload();
                    } else {
                        this.$message({
                            message: "操作失败",
                            type: 'error'
                        });
                    }
                });
            })
        },
        showAddFormDialog(_title, _data) {
            this.dialogTitle = _title
            this.addForm = {
                id: null,
                title: null,
                subTitle: null,
                isOpen: null,
                templateNavType: null,
                sortRank: null,
                parentId: null,
                zoneJumpType: null,
                icon: null,
                isMore: null
            }
            if (_data) {
                this.addForm.id = _data.id;
                this.addForm.title = _data.title;
                this.addForm.subTitle = _data.subTitle;
                this.addForm.isOpen = _data.isOpen;
                this.addForm.templateNavType = _data.templateNavType;
                this.addForm.sortRank = _data.sortRank;
                this.addForm.isMore = _data.isMore;
                this.addForm.parentId = _data.parentId;
                this.addForm.icon = _data.icon;
                this.addForm.zoneJumpType = _data.zoneJumpType;
            }
            this.addFormDialogVisible = true
        },
        closeAddFormDialog() {
            this.addFormDialogVisible = false
        },
        confirmAddFormDialog() {
            saveDiscover(this.addForm).then(resp => {
                if (resp.data.status === 0) {
                    this.$message({
                        message: "操作成功",
                        type: 'success'
                    });
                    this.reload();
                } else {
                    this.$message({
                        message: "操作失败",
                        type: 'error'
                    });
                }
            });
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.detailsSelectorTemp();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.detailsSelectorTemp();
        },
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].childDiscovers.length < 1) {
                    data[i].childDiscovers = undefined;
                } else {
                    this.getTreeData(data[i].childDiscovers);
                }
                data[i].children = data[i].childDiscovers;
            }
        },
        formatDate(row, column) {
            return formatDate(row, column);
        },
        showSelectorDialog: function (row) {
            this.disable = false;
            this.selectorDialogVisible = true;
            this.selector = row;
            this.detailList = []
            this.tempSelectedDetails = [];
            this.selectedDetails = [];
            discoverSelected(this.selector.id).then(resp => {
                if (resp.data.info) {
                    resp.data.info.forEach((info) => {
                        this.selectedDetails.push(info)
                    });
                }
                this.detailsSelectorTemp();
            });
        },
        selectorFunction: function () {
            return this.selector;
        },
        confirmAddSelect(preList) {
            let _this = this;
            let detailSelectors = [];
            let obj = {};
            //构造新的游戏选品list 传给后台
            detailSelectors = preList.reduce((cur, next) => {
                obj[next.id] ? "" : (obj[next.id] = true && cur.push({
                    discoverId: this.selector.id,
                    discoverDetailId: next.id,
                    ranking: next.ranking
                }));
                return cur;
            }, []);
            discoverSelector(_this.selectorFunction().id, detailSelectors).then(resp => {
                if (resp.data.status === 0) {
                    this.closeSelectorFormDialog();
                }
            }).catch(function () {
            });

        },
        closeSelectorFormDialog: function () {
            this.selectedDetails = [];
            this.tempSelectedDetails = [];
            this.selectorDialogVisible = false;
        },
        detailsSelectorTemp() {
            this.flag = false;
            this.detailList.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item, false);
            })
            this.query.page = this.page.page;
            this.query.size = this.page.size;
            allDiscoverDetails(this.query).then(resp => {
                this.detailList = resp.data.info.list;
                this.page.total = resp.data.info.total;
                const ids = [];
                this.selectedDetails.length && this.selectedDetails.forEach(item => {
                    ids.push(item.id)
                });
                const tempSelectedDetails = [];
                ids.length && this.detailList.forEach(item => {
                    if (ids.indexOf(item.id) > -1) {
                        tempSelectedDetails.push(item);
                        this.$refs.multipleTable.toggleRowSelection(item, true);
                    }
                });
                this.disable = false;
                this.tempSelectedDetails = tempSelectedDetails;
                this.$nextTick(() => this.flag = true)
            });
        },
        handleSelectionChange(val) {
            this.disable = true;
            let _this = this;
            val.forEach(function (detail) {
                //设置默认值
                _this.$set(detail, 'ranking', 0);
                _this.selectedDetails.forEach(function (detailsSelector) {
                    if (detail.id === detailsSelector.id) {
                        _this.$set(detail, 'ranking', detailsSelector.rank);
                    }
                })
            });
            _this.tempSelectedDetails = val
        },
        getZoneTypeName(code) {
            const type = this.zoneJumpTypeEnum.find(t => t.code === code);
            return type ? type.name : '';
        },
        rowTableClass({row, rowIndex}) {
            row.index = rowIndex
        },
        getRowKeys(row) {
            return row.id
        },
        deleteRow(index, row) {
            this.disable = true
            this.selectedDetails.splice(index, 1);
            this.detailList.forEach(item => {
                if (item.id === row.id) {
                    this.$refs.multipleTable.toggleRowSelection(item, false);
                    this.tempSelectedDetails.forEach((detail, index) => {
                        if (detail.id === row.id) this.tempSelectedDetails.splice(index, 1)
                    })
                }
            })
        },

        handleIconSuccess(data) {
            this.addForm.icon = data.info;
        },
        beforeIconUpload(data) {
            const type = data.name.substring(data.name.lastIndexOf('.')) === '.png' || data.name.substring(data.name.lastIndexOf('.')) === '.jpg';
            if (!type) {
                this.$message.error('上传图片只能是png,jgp格式!');
            }
            return type;
        },
    },
    watch: {
        tempSelectedDetails: {
            handler(val, oldVal) {
                if (!this.flag) return
                //新增数据判断
                const isAdd = val.length > oldVal.length;
                const oldArr = [], arr = [];
                oldVal.forEach((item) => {
                    oldArr.push(item.id)
                });
                val.forEach((item) => {
                    arr.push(item.id)
                });
                if (isAdd) {
                    let result = [];
                    arr.forEach(id => {
                        if (oldArr.indexOf(id) === -1) {
                            result.push(id)
                        }
                    });
                    result.forEach(id => {
                        val.forEach((item) => {
                            if (item.id === id) this.selectedDetails.unshift(item)
                        })
                    })
                } else {
                    let result = [];
                    oldArr.forEach(id => {
                        if (arr.indexOf(id) === -1) {
                            result.push(id)
                        }
                    });
                    result.forEach(id => {
                        this.selectedDetails.forEach((item, index) => {
                            if (item.id === id) this.selectedDetails.splice(index, 1)
                        })
                    })
                }
            }
        },
    },
    created() {
        allDiscoversEnums().then(resp => {
            this.templateNavTypeEnum = resp.data.info.templateNavTypeEnum;
            this.zoneJumpTypeEnum = resp.data.info.zoneJumpTypeEnum;
        })
        allDiscovers().then(resp => {
            const discoversBefore = resp.data.info;
            this.getTreeData(discoversBefore);
            this.discovers = discoversBefore;
        })
        this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    }

}
</script>

<style scoped>

</style>
